<template>
<div  class="badge text-white" :class="variant"  >
    {{ row.status_fa}}
</div>
</template>

<script>
import Vue from 'vue'
import $ from 'jquery'
export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        variant() {
           return  this.row.status
        }

    }
})
</script>

<style>
.Canceling{
    color: #fff;
    background-color: #9c0f1e;
}
.PosRequest{
    color: #fff;
    background-color: #17a2b8;
}
.PSPVisitor{
    color: #0f0f16;
    background-color: #9dc1d3;
}
.WaitingTax{
    color: #fff;
    background-color: #f7a403;
}
.Correction{
    color: #fff;
    background-color: #a94442;
}
.Switch{
    color: #fff;
    background-color: #1ebeae;
}
.SwitchError{
    color: #fff;
    background-color: #8a6d3b;
}
.Shaparak{
    color: #fff;
    background-color: #1e2b55;
}
.ShaparakQueue{
    color: #fff;
    background-color: #5e5e5e;
}
.ShaparakError{
    color: #fff;
    background-color: #9c0f1e;
}
.Agency{
    color: #fff;
    background-color: #f7a403;
}
.BindSerialToSwitch{
    color: #fff;
    background-color: #f7a403;
}
.IndicatorTransaction{
    color: #fff;
    background-color: #f7a403;
}
.CompletingDocuments{
    color: #fff;
    background-color: #f7a403;
}
.EndOfFlow{
    color: #fff;
    background-color: #f7a403;
}
.Discarded{
    color: #fff;
    background-color: #f7a403;
}
.ChangeAccount{
    color: #fff;
    background-color: #f7a403;
}
.EditRequest{
    color: #fff;
    background-color: #f7a403;
}
.CustomerCreated{
    color: #fff;
    background-color: #f7a403;
}
.CustomerUpdate{
    color: #fff;
    background-color: #f7a403;
}
.Rollback{
    color: #fff;
    background-color: #f7a403;
}

.PosReplacement {
    color: #fff;
    background-color: #f7a403;
}


</style>